import { useMemo } from 'react';

import { taskStatusesConfig } from 'entities';

import { Column } from 'components/Blocks';

import { useProjectProfile } from '../../context';

import { SingleTask } from './SingleTask';
import { sortResult } from 'utils/array';

interface TaskCardsProps {
  disabled?: boolean;
}

export function TaskCards({ disabled }: TaskCardsProps) {
  const { project } = useProjectProfile();

  const sortedTasks = useMemo(() => {
    return project.tasks
      .slice()
      .sort(
        (
          { expectedDate: expectedA, status: statusA },
          { expectedDate: expectedB, status: statusB },
        ) => {
          const defaultDate = '2040-04-22T12:00:00.000';

          const [ACanceled, BCanceled] = [statusA, statusB].map(
            (s) => s === taskStatusesConfig.canceled.code,
          );

          if (ACanceled && !BCanceled) return sortResult('a', 'down');
          if (BCanceled && !ACanceled) return sortResult('b', 'down');

          const [dateA, dateB] = [expectedA, expectedB].map(
            (date) => new Date(date || defaultDate),
          );

          return Number(dateA) - Number(dateB);
        },
      );
  }, [project]);

  return (
    <Column>
      {sortedTasks.map((task) => (
        <SingleTask key={task.id} task={task} disabled={disabled} />
      ))}
    </Column>
  );
}
